import type { QuestionnaireState } from "../../types";

export const handleSetConfigAction = (
  state: QuestionnaireState,
  payload: Record<string, unknown>,
): QuestionnaireState => {
  return {
    ...state,
    config: payload,
  };
};
